import React, { useEffect, useState } from 'react'
import { Alert, TextField, Typography } from '@mui/material'
import API from '../../services/API'
import ConfirmDialog from '../kit/ConfirmDialog'

// The Clinical Safety Officer's sign-off of one course version. Signing off
// makes the version live for every organisation and cannot be undone: a
// signed-off version never changes, it can only be superseded.
const SignOffDialog = ({ version, onClose, onSaved }) => {
  const [note, setNote] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (version) {
      setNote('')
      setError(null)
    }
  }, [version])

  if (!version) return null
  const confirmText = `${version.code} ${version.version}`

  const handleConfirm = async () => {
    setBusy(true)
    setError(null)
    const res = await API.post(`/admincrm/training/courses/${version.code}/${version.version}/sign-off`, {
      confirm: confirmText,
      note,
    })
    setBusy(false)
    if (res.status === 200) onSaved(res.data)
    else setError(res.data?.error ?? res.data?.message ?? 'Unable to record the sign-off')
  }

  return (
    <ConfirmDialog
      open
      title={`Sign off ${version.code} ${version.title}`}
      confirmLabel="Sign off and make live"
      requireText={confirmText}
      busy={busy}
      error={error}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      <Typography variant="body2">
        By signing off you confirm, as Clinical Safety Officer, that you have reviewed the storyboard and the question
        bank for version {version.version} and that the course is fit to use. Your name and today's date are recorded
        against it.
      </Typography>
      <Alert severity="warning">
        This makes the course live for every organisation and cannot be undone. A signed-off version can never be
        changed; a correction needs a new version.
      </Alert>
      <TextField
        label="Note (optional)"
        value={note}
        onChange={(event) => setNote(event.target.value)}
        size="small"
        fullWidth
        multiline
        minRows={2}
        inputProps={{ maxLength: 1000 }}
      />
    </ConfirmDialog>
  )
}

export default SignOffDialog
